import React, { useState, useEffect, useRef } from "react";
import Graph from "react-vis-network-graph";
import isEqual from "lodash/isEqual";
import VouchStats from "./VouchStats";
import "./styles.css"; // Import a CSS file for additional styling

// Function to shorten the string
const shortenString = (str) => {
  if (str.length <= 8) {
    return str; // If the string is too short, just return it as is
  }
  return `${str.slice(2, 6)}...${str.slice(-4)}`;
};

const VouchGraph = React.memo(
  ({ data }) => {
    const [selectedNode, setSelectedNode] = useState(data[0].address);
    const [graph, setGraph] = useState({ nodes: [], edges: [] });
    const prevDataRef = useRef();

    const handleChange = (event) => {
      setSelectedNode(event.target.value);
    };

    useEffect(() => {
      if (prevDataRef.current && isEqual(prevDataRef.current, data)) {
        return;
      }

      const involvedNodes = new Set();
      const filteredEdges = [];
      const edgeSet = new Set();
      const incomingEdgesCount = {};

      data.forEach((node) => {
        if (node.address === selectedNode) {
          involvedNodes.add(node.address);
          node.true_friends.forEach((voucher) => {
            involvedNodes.add(voucher);
            const edgeId = `${voucher}-${node.address}`;

            let voucher_node = data.find((each) => each.address === voucher);
            if (
              voucher_node &&
              voucher_node.all_vouchers.includes(node.address)
            ) {
              filteredEdges.push({
                id: edgeId,
                from: voucher,
                to: node.address,
                color: { color: "green" },
                arrows: { to: true, from: true }, // Setas bidirecionais
              });
            } else {
              filteredEdges.push({
                id: edgeId,
                from: voucher,
                to: node.address,
                color: { color: "#ffae42" },
              });
            }
          });
        }
      });

      const filteredNodes = data
        .filter((node) => involvedNodes.has(node.address))
        .map((node) => ({
          id: node.address,
          label: node.user || shortenString(node.address),
          shape: "ellipse",
          widthConstraint: { maximum: 100 },
          heightConstraint: { maximum: 100 },
          color: node.in_set ? "green" : "gray",
          font: {
            color: "white",
          },
        }));
      setGraph({ nodes: filteredNodes, edges: filteredEdges });
    }, [selectedNode, data]);

    const options = {
      layout: {
        hierarchical: false,
      },
      physics: {
        enabled: true,
        solver: "forceAtlas2Based",
        forceAtlas2Based: {
          gravitationalConstant: -50,
          centralGravity: 0.01,
          springLength: 230,
          springConstant: 0.18,
        },
        maxVelocity: 146,
        minVelocity: 3,
        solver: "forceAtlas2Based",
      },
      edges: {
        color: "#000000",
      },
      height: "800px",
    };

    return (
      <div>
        <select
          onChange={handleChange}
          value={selectedNode}
          className="dropdown"
        >
          {data.map((node) => (
            <option key={node.address} value={node.address}>
              {node.short_address + node.user}
            </option>
          ))}
        </select>
        <VouchStats node={data.find((each) => each.address === selectedNode)} />
        <Graph
          key={`${selectedNode}-${Date.now()}`}
          graph={graph}
          options={options}
        />
      </div>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps.data, nextProps.data)
);

export default VouchGraph;
